import React from 'react';
import LabelGroupList from './LabelGroupList';
import { Tags, Info } from 'lucide-react';

interface Props {}

interface State {}

const labelGroups = [
    {
        value: 'customer',
        title: 'Customer',
    },
    {
        value: 'order',
        title: 'Repair Order',
    },
    {
        value: 'partStatus',
        title: 'Part Status',
    },
    {
        value: 'laborStatus',
        title: 'Labor Status',
    },
];

class LabelSettings extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }
    render() {
        return (
            <div className="flex flex-col  bg-gray-50">
                {/* Header */}
                <div className="bg-white border-b border-gray-200 px-8 py-6">
                    <div className="flex items-center justify-between">
                        <div>
                            <nav className="flex items-center space-x-2 text-sm text-gray-500 mb-2">
                                <span>Settings</span>
                                <span>/</span>
                                <span className="text-blue-600 font-semibold">Labels</span>
                            </nav>
                            <h2 className="text-3xl font-bold text-gray-900">Custom Labels</h2>
                            <p className="text-gray-600 mt-1">
                                Configure custom color-coded labels to organize and categorize different entities in
                                your system.
                            </p>
                        </div>
                        <div className="flex items-center space-x-3">
                            <div className="bg-blue-100 p-3 rounded-lg">
                                <Tags className="h-8 w-8 text-blue-600" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="flex-1 p-8">
                    {/* Label Groups */}
                    <div className="space-y-8">
                        {labelGroups.map((labelType, index) => (
                            <LabelGroupList labelType={labelType} key={index} />
                        ))}
                    </div>

                    {/* Info Panel */}
                    <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-6">
                        <div className="flex gap-4">
                            <Info className="w-6 h-6 text-blue-600 flex-shrink-0 mt-0.5" />
                            <div className="text-sm text-blue-800">
                                <h4 className="font-semibold mb-3 text-lg">How Custom Labels Work</h4>
                                <ul className="space-y-2 text-blue-700">
                                    <li className="flex items-start gap-2">
                                        <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 flex-shrink-0"></span>
                                        Create color-coded labels to categorize customers, repair orders, parts, and
                                        labor status
                                    </li>
                                    <li className="flex items-start gap-2">
                                        <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 flex-shrink-0"></span>
                                        Labels help you quickly identify and organize different items throughout the
                                        system
                                    </li>
                                    <li className="flex items-start gap-2">
                                        <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 flex-shrink-0"></span>
                                        Choose custom colors to match your workflow and make labels easily recognizable
                                    </li>
                                    <li className="flex items-start gap-2">
                                        <span className="w-1.5 h-1.5 bg-blue-600 rounded-full mt-2 flex-shrink-0"></span>
                                        Labels can be applied to multiple items and help with filtering and reporting
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LabelSettings;
